"use client";

import { START_TIMING_OPTIONS, startDateInputBounds } from "@/features/leads/shared/start-timing";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";
import { fieldBaseClass, labelClass } from "@/shared/ui/form/field-styles";
import { RadioCards } from "@/shared/ui/form/RadioCards";

export function StartStep() {
  const { state, update, autoAdvance, goToStep, step, stepReady, isBusiness } = useWizard();
  const recurring = (isBusiness ? state.businessTask : state.task) === "lobende";
  const needsDate = state.startTiming === "SPECIFIK_DATO";
  const dateBounds = startDateInputBounds();

  return (
    <section>
      <StepHeading
        title={recurring ? "Hvornår skal rengøringen starte?" : "Hvornår skal opgaven løses?"}
        body={
          recurring
            ? "Så kan firmaet give dig et tilbud med en start, der passer dig."
            : "Så kan firmaet give dig et tilbud på et tidspunkt, der passer dig."
        }
        maxW="max-w-[24ch]"
      />
      <RadioCards
        options={START_TIMING_OPTIONS}
        value={state.startTiming}
        onChange={(v) => {
          update("startTiming", v);
          if (v !== "SPECIFIK_DATO") autoAdvance();
        }}
        gridClassName="grid-cols-2 sm:grid-cols-3"
      />

      {needsDate && (
        <div className="mt-6">
          <label htmlFor="wiz-start-date" className={labelClass}>
            Dato
          </label>
          <input
            id="wiz-start-date"
            type="date"
            min={dateBounds.min}
            max={dateBounds.max}
            value={state.startDate}
            onChange={(e) => update("startDate", e.target.value)}
            className={`${fieldBaseClass} max-w-56`}
          />
          <p className="mt-2 text-[13px] text-ink-subtle">
            Kender du ikke den præcise dag, så vælg den første dag der kunne passe.
          </p>
        </div>
      )}

      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("start")}
        nextLabel="Næste →"
      />
    </section>
  );
}
